import { Routes, Route } from "react-router-dom";
import InputForm from "./pages/inputform";
import Results from "./pages/results";
import RequestCode from "./pages/requestcode";
import VoucherCreator from "./pages/vouchercreator";

function App() {
  return (
    <Routes>
      <Route path="/input/:code" element={<InputForm />} />
      <Route path="/results/:code" element={<Results />} />
      <Route path="/requestcode" element={<RequestCode />} />
      <Route path="/vouchercreator" element={<VoucherCreator />} />
    </Routes>
  );
}

export default App;

